import { environment } from '../../../environments/environment';

/**
 * Retorna true quando o ambiente atual e o pre-prod interno da AgSUS
 * e deve liberar acoes de escrita (editar/criar/excluir) mesmo durante
 * modo simulacao. Em qualquer outro ambiente (dev/hmo/prd/local) retorna false.
 *
 * O valor e lido do campo opcional preprodFullAccess do environment.
 * Uso de type assertion porque o campo e opcional no tipo inferido de
 * cada environment.*.ts local (arquivos gitignored).
 */
export function isPreprodFullAccess(): boolean {
  return (environment as unknown as { preprodFullAccess?: boolean }).preprodFullAccess === true;
}
